import axios from 'axios';
import { endpoint } from '../constants/endpoints';

export type TokenValidationResponse = {
  valid: boolean;
  userName: string;
  warehouseId: string;
  expiresAt: number;
};

export type TokenValidationError = {
  message: string;
};

const allowedOrigin =
  process.env.REACT_APP_ORIGIN_HEADER || 'https://gateway.lynedirect.com/sort';

const buildHeaders = (authorizationToken: string) => ({
  origin: allowedOrigin,
  Authorization: `Bearer ${authorizationToken}`,
});

export const validateToken = async (
  authorizationToken: string
): Promise<TokenValidationResponse | TokenValidationError> => {
  const headers = buildHeaders(authorizationToken);

  try {
    const result = await axios.get(endpoint.VALIDATE_TOKEN, { headers });
    return result.data as TokenValidationResponse;
  } catch (error: any) {
    if (error.response) {
      return {
        message: error.response.data.message || 'Token validation failed',
      } as TokenValidationError;
    }

    return {
      message: 'Network Error',
    } as TokenValidationError;
  }
};
